import { useParams, useLocation, useNavigate } from 'react-router-dom';
import CaChatModal from './CaChatView'; 

export default function ChatPage() {
  const { ticketId } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();

  const ticket = state?.ticket;

  return (
    <CaChatModal
      ticket={{ id: ticketId, ...ticket }}
      currentUser={localStorage.getItem('fullName')}
      onClose={() => navigate(-1)}   // go back
    />
  );
}
